 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		49: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"styles","3":"component---src-docs-template-js","4":"component---src-pages-404-js","5":"component---src-pages-about-js","6":"component---src-pages-anti-spam-policy-js","7":"component---src-pages-articles-amazon-ses-alternatives-js","8":"component---src-pages-articles-best-transactional-email-platform-js","9":"component---src-pages-articles-brevo-alternatives-js","10":"component---src-pages-articles-dark-mode-in-html-email-js","11":"component---src-pages-articles-js","12":"component---src-pages-articles-mailgun-alternatives-js","13":"component---src-pages-articles-mandrill-alternatives-js","14":"component---src-pages-articles-postmark-alternatives-js","15":"component---src-pages-articles-sendgrid-alternatives-js","16":"component---src-pages-articles-transactional-email-vs-marketing-email-js","17":"component---src-pages-articles-what-is-email-api-js","18":"component---src-pages-articles-what-is-transactional-email-js","19":"component---src-pages-automated-email-sequences-js","20":"component---src-pages-contact-js","21":"component---src-pages-contact-profiles-js","22":"component---src-pages-customer-reviews-js","23":"component---src-pages-email-marketing-js","24":"component---src-pages-email-open-tracking-js","25":"component---src-pages-email-sending-api-js","26":"component---src-pages-index-js","27":"component---src-pages-no-code-email-editor-js","28":"component---src-pages-press-js","29":"component---src-pages-pricing-js","30":"component---src-pages-privacy-js","31":"component---src-pages-subscribe-forms-js","32":"component---src-pages-targeted-email-messages-js","33":"component---src-pages-terms-js","34":"component---src-pages-transactional-email-templates-account-activation-email-template-js","35":"component---src-pages-transactional-email-templates-canceled-subscription-email-template-js","36":"component---src-pages-transactional-email-templates-invoice-email-template-js","37":"component---src-pages-transactional-email-templates-js","38":"component---src-pages-transactional-email-templates-login-alert-email-template-js","39":"component---src-pages-transactional-email-templates-new-message-notification-email-template-js","40":"component---src-pages-transactional-email-templates-new-organization-member-email-template-js","41":"component---src-pages-transactional-email-templates-organization-invite-email-template-js","42":"component---src-pages-transactional-email-templates-password-reset-email-template-js","43":"component---src-pages-transactional-email-templates-payment-failed-email-template-js","44":"component---src-pages-transactional-email-templates-receipt-email-template-js","45":"component---src-pages-transactional-email-templates-sso-email-template-js","46":"component---src-pages-transactional-email-templates-trial-expired-email-template-js","47":"component---src-pages-transactional-email-templates-verification-code-email-template-js","48":"component---src-pages-transactional-email-templates-welcome-email-template-js"}[chunkId]||chunkId) + "-" + {"1":"44fd9b59d5803ccc8ddd","3":"3daae22c8cf01c7c3b39","4":"c4b18d2f078d7ae4c19b","5":"9fe32f06c2c5ea720640","6":"b93e5dadc02925d8c83a","7":"265bb2b86a4787d9a251","8":"1a86d577301efccd8228","9":"e4a37d5c032c614fcb1f","10":"7fc6a471cfaead46080e","11":"b76d8638cdb269319d96","12":"45b799483d5659dba783","13":"8a67fad06ca1b7d86707","14":"277fc851e81b0bc621fb","15":"9a65a5a4500309ad1cc5","16":"61bd3aaef34b7ab20c4b","17":"ed2f1bda1b67fcbbf6ca","18":"32657bbb3ab254dd59a4","19":"06a7289feca4cb9e2858","20":"ee07ee3dc248cbc5593b","21":"2e9c3b91d87e267d399a","22":"334232df7a553270a435","23":"ca3894d1478c6cbe6802","24":"78993d42c1791be0d13d","25":"a7540012abce533ba887","26":"5164d172cc9f63999f9a","27":"94a873eb48263f8e3378","28":"a22468e808bc8e849b37","29":"9e223ddad14444eb0d02","30":"f36025468c5107a662d5","31":"d28badbf34401ecfbad8","32":"25be58e3b1833fa7f7ce","33":"70d760a1690f27de8e5a","34":"bde435ecb94e15c90148","35":"9a590cdb6b980341f989","36":"056a296baaa9ed7f9ac1","37":"26c45b77a3ed0e42f752","38":"d9e0e2f4beafc081d1e8","39":"7e761e8f5e05fff4c6e3","40":"6e822504e8cd8820b0e0","41":"dd7ec42368ef76a81150","42":"e7fb0b8a3c867b8cbaa4","43":"630305f037336591fd6c","44":"2c6f79ab8cfb1adc0a3b","45":"6299dbc29e8c583d6674","46":"13a4403c630412345a71","47":"aed5d62babf1d2cdded0","48":"271f1915e9cd6d084d24","50":"f7a13cd897e95814afad"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"1":"styles","3":"component---src-docs-template-js","4":"component---src-pages-404-js","5":"component---src-pages-about-js","6":"component---src-pages-anti-spam-policy-js","7":"component---src-pages-articles-amazon-ses-alternatives-js","8":"component---src-pages-articles-best-transactional-email-platform-js","9":"component---src-pages-articles-brevo-alternatives-js","10":"component---src-pages-articles-dark-mode-in-html-email-js","11":"component---src-pages-articles-js","12":"component---src-pages-articles-mailgun-alternatives-js","13":"component---src-pages-articles-mandrill-alternatives-js","14":"component---src-pages-articles-postmark-alternatives-js","15":"component---src-pages-articles-sendgrid-alternatives-js","16":"component---src-pages-articles-transactional-email-vs-marketing-email-js","17":"component---src-pages-articles-what-is-email-api-js","18":"component---src-pages-articles-what-is-transactional-email-js","19":"component---src-pages-automated-email-sequences-js","20":"component---src-pages-contact-js","21":"component---src-pages-contact-profiles-js","22":"component---src-pages-customer-reviews-js","23":"component---src-pages-email-marketing-js","24":"component---src-pages-email-open-tracking-js","25":"component---src-pages-email-sending-api-js","26":"component---src-pages-index-js","27":"component---src-pages-no-code-email-editor-js","28":"component---src-pages-press-js","29":"component---src-pages-pricing-js","30":"component---src-pages-privacy-js","31":"component---src-pages-subscribe-forms-js","32":"component---src-pages-targeted-email-messages-js","33":"component---src-pages-terms-js","34":"component---src-pages-transactional-email-templates-account-activation-email-template-js","35":"component---src-pages-transactional-email-templates-canceled-subscription-email-template-js","36":"component---src-pages-transactional-email-templates-invoice-email-template-js","37":"component---src-pages-transactional-email-templates-js","38":"component---src-pages-transactional-email-templates-login-alert-email-template-js","39":"component---src-pages-transactional-email-templates-new-message-notification-email-template-js","40":"component---src-pages-transactional-email-templates-new-organization-member-email-template-js","41":"component---src-pages-transactional-email-templates-organization-invite-email-template-js","42":"component---src-pages-transactional-email-templates-password-reset-email-template-js","43":"component---src-pages-transactional-email-templates-payment-failed-email-template-js","44":"component---src-pages-transactional-email-templates-receipt-email-template-js","45":"component---src-pages-transactional-email-templates-sso-email-template-js","46":"component---src-pages-transactional-email-templates-trial-expired-email-template-js","47":"component---src-pages-transactional-email-templates-verification-code-email-template-js","48":"component---src-pages-transactional-email-templates-welcome-email-template-js"}[chunkId]||chunkId) + "." + {"1":"1d89e973eefcc31e0f74","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
